import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import MuiBackdrop from '@mui/material/Backdrop';
const loaderStyle = {
    display: 'inline-block',
    width: '265px',
    height: '265px',
    margin: 'auto',
    position: 'absolute',
    inset: 0,
    zIndex: 99999,
    boxShadow: 'rgba(33, 33, 33, 0.2) 0px 0px 0px 5000px',
    backgroundColor: 'rgba(33, 33, 33, 0.2)',
    '&:after': {
        content: '" "',
        display: 'block',
        width: '250px',
        height: '250px',
        margin: '8px',
        borderRadius: '50%',
        border: '3px solid #ffffff',
        borderColor: '#0358a3 transparent #f58320 transparent',
        animation: 'base-loader 1.2s linear infinite',
    },
    ' @keyframes base-loader': {
        '0%': {
            transform: 'rotate(0deg)',
        },
        '100%': {
            transform: ' rotate(360deg)',
        },
    },
};
const Message = ({ color, children }) => (<Typography variant='h4' color={color} sx={{ mt: -25 }}>
		{children}
	</Typography>);
export const Backdrop = ({ isOpen, text, color = 'white', coverFullScreen = true }) => {
    return coverFullScreen ? (<Modal open={!!isOpen} sx={{ justifyContent: 'space-around' }}>
			<Box display='flex' height='100%' width='100%' alignItems='center' justifyContent='center'>
				<Box display='flex' flexDirection='column' gap={3}>
					<Box sx={loaderStyle}/>
					{!!text && <Message color={color}>{text}</Message>}
				</Box>
			</Box>
		</Modal>) : (<MuiBackdrop open={!!isOpen} sx={theme => ({ display: 'flex', flexDirection: 'column', gap: 3, zIndex: theme.zIndex.modal })}>
			<Box sx={loaderStyle}/>
			{!!text && <Message color={color}>{text}</Message>}
		</MuiBackdrop>);
};
//# sourceMappingURL=Backdrop.jsx.map